import isString from "lodash/isString";
const localeKey = "e9_locale";
export const getLabel = (id = "", defaultValue, type) => {
  let loc = window[localeKey] || {};
  if (type) {
    loc = loc[type];
  } else {
    loc = loc.label;
  }
  if (!loc) return defaultValue || "";
  let text = loc[id];
  if (isString(id) && id.indexOf(",") > -1) {
    //支持逗号分割
    text = id.split(",").reduce((t, c, i) => `${i == 1 ? loc[t] : t}${loc[c]}`);
  }
  if (isString(text) && text.indexOf("undefined") > -1 && defaultValue) {
    text = defaultValue;
    // addLabelLog(id, defaultValue)
  }
  let str = text || defaultValue;
  if (!text) {
    // addLabelLog(id, defaultValue)
  }
  return formatStr(str);
};

export const getCommonLocale = () => {
  return {
    Popconfirm: {
      okText: getLabel(16631, "确认"),
      cancelText: getLabel(201, "取消"),
      justOkText: getLabel(383773, "知道了"),
      confirmTitle: getLabel(131329, "信息确认")
    },
    Pagination: {
      total: getLabel("83698", "共"),
      totalUnit: getLabel("128218", "条"),
      operates: getLabel("30585", "操作"),
      items_per_page: getLabel("386261", "条/页"),
      jump_to: getLabel("386262", "跳至"),
      page: getLabel("30642", "页"),
      first_page: getLabel("386263", "第一页"),
      last_page: getLabel("386264", "最后一页"),
      prev_page: getLabel("1258", "上一页"),
      next_page: getLabel("1259", "下一页"),
      prev_5: getLabel("386265", "向前 5 页"),
      next_5: getLabel("386266", "向后 5 页")
    },
    DatePicker: {
      lang: {
        placeholder: getLabel("27938", "请选择日期"),
        rangePlaceholder: [
          getLabel("24978", "开始日期"),
          getLabel("24980", "结束日期")
        ],
        today: getLabel("15537", "今天"),
        now: getLabel("386451", "此刻"),
        backToToday: getLabel("386452", "返回今天"),
        ok: getLabel("826", "确定"),
        clear: getLabel("311", "清除"),
        month: getLabel("33452", "月"),
        year: getLabel("26577", "年"),
        previousMonth: getLabel("386453", "上个月 (翻页上键)"),
        nextMonth: getLabel("386454", "下个月 (翻页下键)"),
        monthSelect: getLabel("386455", "选择月份"),
        yearSelect: getLabel("386456", "选择年份"),
        decadeSelect: getLabel("386457", "选择年代"),
        yearFormat: getLabel("386465", "yyyy'年'"),
        monthFormat: getLabel("386466", "M'月'"),
        dateFormat: getLabel("386467", "yyyy'年'M'月'd'日'"),
        previousYear: getLabel("386458", "上一年 (Control键加左方向键)"),
        nextYear: getLabel("386459", "下一年 (Control键加右方向键)"),
        previousDecade: getLabel("386460", "上一年代"),
        nextDecade: getLabel("386461", "下一年代"),
        previousCentury: getLabel("386462", "上一世纪"),
        nextCentury: getLabel("386463", "下一世纪"),
        format: {
          eras: [getLabel("383357", "公元前"), getLabel("383358", "公元")],
          months: [
            getLabel("1492", "一月"),
            getLabel("1493", "二月"),
            getLabel("1494", "三月"),
            getLabel("1495", "四月"),
            getLabel("1496", "五月"),
            getLabel("1497", "六月"),
            getLabel("1498", "七月"),
            getLabel("1499", "八月"),
            getLabel("1800", "九月"),
            getLabel("1801", "十月"),
            getLabel("1802", "十一月"),
            getLabel("1803", "十二月")
          ],
          shortMonths: [
            getLabel("25825", "1月"),
            getLabel("25826", "2月"),
            getLabel("25827", "3月"),
            getLabel("25828", "4月"),
            getLabel("25829", "5月"),
            getLabel("25830", "6月"),
            getLabel("25831", "7月"),
            getLabel("25832", "8月"),
            getLabel("25833", "9月"),
            getLabel("25834", "10月"),
            getLabel("25835", "11月"),
            getLabel("25836", "12月")
          ],
          weekdays: [
            getLabel("24626", "星期天"),
            getLabel("392", "星期一"),
            getLabel("393", "星期二"),
            getLabel("394", "星期三"),
            getLabel("395", "星期四"),
            getLabel("396", "星期五"),
            getLabel("397", "星期六")
          ],
          shortWeekdays: [
            getLabel("16106", "周日"),
            getLabel("16100", "周一"),
            getLabel("16101", "周二"),
            getLabel("16102", "周三"),
            getLabel("16103", "周四"),
            getLabel("16104", "周五"),
            getLabel("16105", "周六")
          ],
          veryShortWeekdays: [
            getLabel("385820", "日"),
            getLabel("385821", "一"),
            getLabel("385822", "二"),
            getLabel("385823", "三"),
            getLabel("385824", "四"),
            getLabel("385825", "五"),
            getLabel("385826", "六")
          ],
          ampms: [getLabel("16689", "上午"), getLabel("16690", "下午")],
          datePatterns: [
            "yyyy'年'M'月'd'日' EEEE",
            "yyyy'年'M'月'd'日'",
            "yyyy-M-d",
            "yy-M-d"
          ],
          timePatterns: [
            "ahh'时'mm'分'ss'秒' 'GMT'Z",
            "ahh'时'mm'分'ss'秒'",
            "H:mm:ss",
            "ah:mm"
          ],
          dateTimePattern: "{date} {time}"
        }
      },
      timePickerLocale: {
        clear: getLabel("311", "清除"),
        placeholder: getLabel("386464", "请选择时间"),
        format: {
          eras: [getLabel("383357", "公元前"), getLabel("383358", "公元")],
          months: [
            getLabel("1492", "一月"),
            getLabel("1493", "二月"),
            getLabel("1494", "三月"),
            getLabel("1495", "四月"),
            getLabel("1496", "五月"),
            getLabel("1497", "六月"),
            getLabel("1498", "七月"),
            getLabel("1499", "八月"),
            getLabel("1800", "九月"),
            getLabel("1801", "十月"),
            getLabel("1802", "十一月"),
            getLabel("1803", "十二月")
          ],
          shortMonths: [
            getLabel("25825", "1月"),
            getLabel("25826", "2月"),
            getLabel("25827", "3月"),
            getLabel("25828", "4月"),
            getLabel("25829", "5月"),
            getLabel("25830", "6月"),
            getLabel("25831", "7月"),
            getLabel("25832", "8月"),
            getLabel("25833", "9月"),
            getLabel("25834", "10月"),
            getLabel("25835", "11月"),
            getLabel("25836", "12月")
          ],
          weekdays: [
            getLabel("24626", "星期天"),
            getLabel("392", "星期一"),
            getLabel("393", "星期二"),
            getLabel("394", "星期三"),
            getLabel("395", "星期四"),
            getLabel("396", "星期五"),
            getLabel("397", "星期六")
          ],
          shortWeekdays: [
            getLabel("16106", "周日"),
            getLabel("16100", "周一"),
            getLabel("16101", "周二"),
            getLabel("16102", "周三"),
            getLabel("16103", "周四"),
            getLabel("16104", "周五"),
            getLabel("16105", "周六")
          ],
          veryShortWeekdays: [
            getLabel("385820", "日"),
            getLabel("385821", "一"),
            getLabel("385822", "二"),
            getLabel("385823", "三"),
            getLabel("385824", "四"),
            getLabel("385825", "五"),
            getLabel("385826", "六")
          ],
          ampms: [getLabel("16689", "上午"), getLabel("16690", "下午")],
          datePatterns: [
            "yyyy'年'M'月'd'日' EEEE",
            "yyyy'年'M'月'd'日'",
            "yyyy-M-d",
            "yy-M-d"
          ],
          timePatterns: [
            "ahh'时'mm'分'ss'秒' 'GMT'Z",
            "ahh'时'mm'分'ss'秒'",
            "H:mm:ss",
            "ah:mm"
          ],
          dateTimePattern: "{date} {time}"
        },
        calendar: {
          timezoneOffset: 8 * 60,
          firstDayOfWeek: 1,
          minimalDaysInFirstWeek: 1
        }
      }
    }
  };
};

const formatStr = str => {
  return str.replace(/&quot;/g, '"');
};



// WEBPACK FOOTER //
// ./ecology9/wea-locale-provider/util.js